import {ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import {CommonModule, CurrencyPipe, DatePipe, DecimalPipe} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ToastModule} from 'primeng/toast';
import {RippleModule} from 'primeng/ripple';
import {TooltipModule} from 'primeng/tooltip';
import {ImageCropperModule} from 'ngx-image-cropper';
import {FileUploadModule} from 'primeng/fileupload';
import {
  provideTranslateService,
  TranslateLoader,
  TranslatePipe
} from '@ngx-translate/core';
import {HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfirmationService, MessageService} from 'primeng/api';
import {DomainValuePipe} from './pipes/domain-value.pipe';
import {RegionNumberPipe} from './pipes/region-number.pipe';
import {AddressPipe} from './pipes/address.pipe';
import {DatabasePipe} from './pipes/database.pipe';
import {ProductCategoryPipe} from './pipes/product-category.pipe';
import {InvoiceNumberPipe} from './modules/backend/faktura-module/pipes/invoiceNumber.pipe';
import {PlayerPipe} from './pipes/player.pipe';
import {DurationPipe} from './pipes/duration.pipe';
import {ParticipantPipe} from './pipes/participant.pipe';
import {MatchreportStructurePipe} from './pipes/matchreportStructure.pipe';
import {NumberFillUpPipe} from './pipes/numberFillUp.pipe';
import {MatchResultPipe} from './pipes/match-result.pipe';
import {HistoryFieldPipe} from './pipes/history-field.pipe';
import {DatatypeValuePipe} from './modules/shared/pipes/datatype-value.pipe';
import {WeekdayPipe} from './pipes/weekday.pipe';
import {LocationPipe} from './modules/shared/pipes/location.pipe';
import {SetlegmodePipe} from './pipes/setlegmode.pipe';
import {RoundDatePipe} from './pipes/roundDate.pipe';
import {MatchDatePipe} from './pipes/matchDate.pipe';
import {tokenInterceptor} from './services/auth/TokenInterceptor';
import {CustomErrorHandlerService} from './services/error-handler';
import {BackendPreset} from './themes/backend.preset';
import {InputTextModule} from 'primeng/inputtext';
import {
  customTranslateLoaderFactory
} from './services/translations/custom-translate-http-loader';
import {AveragePipe} from './pipes/average.pipe';


export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(CommonModule,
      AppRoutingModule,
      BrowserModule,
      ConfirmDialogModule,
      ToastModule,
      RippleModule,
      TooltipModule,
      ImageCropperModule,
      FileUploadModule,
      InputTextModule,
      ProgressSpinnerModule),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: BackendPreset,
        options: {
          darkModeSelector: 'none'
          // darkModeSelector: '.p-dark'
        },
      }
    }),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: customTranslateLoaderFactory,
        deps: [HttpClient]
      },
    }),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    DatePipe,
    CurrencyPipe,
    DialogService,
    MessageService,
    TranslatePipe,
    DomainValuePipe,
    RegionNumberPipe,
    AddressPipe,
    DecimalPipe,
    DatabasePipe,
    ProductCategoryPipe,
    InvoiceNumberPipe,
    PlayerPipe,
    DurationPipe,
    ParticipantPipe,
    MatchreportStructurePipe,
    NumberFillUpPipe,
    MatchResultPipe,
    HistoryFieldPipe,
    DatatypeValuePipe,
    WeekdayPipe,
    LocationPipe,
    SetlegmodePipe,
    RoundDatePipe,
    MatchDatePipe,
    AveragePipe,
    ConfirmationService,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE' // 'de-DE' for Germany, 'fr-FR' for France ...
    },
    { provide: ErrorHandler, useClass: CustomErrorHandlerService },
    provideHttpClient(
      withInterceptors([tokenInterceptor])
    )
  ]
};
